import './Icon_Hamburger.css';
 
function Icon_Hamburger() {
  return (
   
      <div className='icon-container'>
          <svg viewBox="0 0 24 24" className="responsive-svg">
              <path d="M3 5h18"/><path d="M3 12h18"/><path d="M3 19h18"/>
          </svg>
      </div>
           
  );
}
 
export default Icon_Hamburger;
 
 